module.exports = __webpack_public_path__ + "img/didacticiel-scroll.ffffbef4.svg";